import React, { useEffect, useRef, useState } from "react";
import { string, func } from 'prop-types';

const Embed = ({
  title = 'SDP Visualize',
  src = '',
  windowHeight = 0,
  onMessage = () => {},
  onLocationChange = () => {},
  onFrameChange = () => {},
  ...props
}) => {
  // ref for the iframe HTML element
  const iframeEl = useRef(null);
  // ref for the current `frameSrc` attribute
  const frameSrc = useRef(src);
  // ref for the current location, as reported via postMessage
  const location = useRef(null);
  const [frame, setFrame] = useState();

  function useInnerHeight() {
    const [innerHeight, setInnerHeight] = useState(window.innerHeight);
    useEffect(() => {
      const onResize = () => setInnerHeight(window.innerHeight);
      window.addEventListener('resize', onResize);
      return () => window.removeEventListener('resize', onResize);
    }, []);
    return innerHeight - 65;
  }

  const innerHeight = useInnerHeight();

  // setup postMessage listener
  useEffect(() => {
    const handleMessage = (e) => {
      if (e.source === iframeEl.current.contentWindow && e.data.metabase) {
        // sync the location ref
        if (e.data.metabase.type === 'location') {
          const { pathname, search, hash } = e.data.metabase.location;
          location.current = [pathname, search, hash].join('');
          if (onLocationChange) {
            onLocationChange(e.data.metabase.location);
          }
        } else if (e.data.metabase.type === 'frame') {
          setFrame(e.data.metabase.frame);
          if (onFrameChange) {
            onFrameChange(e.data.metabase.frame);
          }
        }
        if (onMessage) {
          onMessage(e.data.metabase);
        }
      }
    };
    window.addEventListener('message', handleMessage);
    return () => {
      window.removeEventListener('message', handleMessage);
    };
  }, []);

  // if (location.current == null) {
  //   // location syncing not enabled, update frameSrc
  //   frameSrc.current = src;
  // } else if (location.current !== path) {
  //   // location syncing enabled, use postMessage to update location
  //   iframeEl.current.contentWindow.postMessage(
  //     {
  //       metabase: {
  //         type: 'location',
  //         location: path
  //       }
  //     },
  //     // FIXME SECURITY: use whitelisted origin instead of "*"
  //     '*'
  //   );
  // }

  // on first load replace the frameSrc with the auth URL, if any
  // if (getAuthUrl && !iframeEl.current) {
  //   frameSrc.current = getAuthUrl(frameSrc.current);
  // }

  // const frameMode = frame && frame.mode;
  // const height =
  //   frameMode === 'normal'
  //     ? frame.height
  //     : frameMode === 'fit' && fitHeight != null
  //     ? fitHeight
  //     : undefined;

  useEffect(() => console.log(title, frameSrc.current, { iframeEl, frame }), []);

  return iframeEl ? (
    <iframe
      ref={iframeEl}
      src={frameSrc.current}
      title={title}
      className={props?.className}
      style={{
        border: 'none',
        width: '100%',
        height: innerHeight,
        overflow: 'hidden'
      }}
    />
  ) : (
    <h1>Loading...</h1>
  );
};

Embed.propTypes = {
  title: string,
  src: string.isRequired,
  windowHeight: string,
  onMessage: func,
  onLocationChange: func,
  onFrameChange: func
};

export default Embed;
